import { BlobServiceClient } from '@azure/storage-blob'
import { logEvent } from 'firebase/analytics'
import { analytics } from './firebaseConfig'
import { getCDN } from './getEnvironment'
import { fetchSASToken } from './fetchSASToken'

export const download = async (
  apptitle,
  app,
  os,
  idToken,
  setSessionExpired
) => {
  const container = app.foldername
  const responseToken = await fetchSASToken(idToken, setSessionExpired)
  console.log('responseToken.data.sasToken: ', responseToken.data.sasToken)

  console.log('appTitle: ', container)

  if (os === 'iOS') {
    await logEvent(analytics, `${container}-iOS`, {
      platform: 'iOS',
    })

    console.log(
      `${getCDN()}${container}/manifest.plist?` + responseToken.data.sasToken
    )

    const uri = encodeURIComponent(
      `${getCDN()}${container}/manifest.plist?` + responseToken.data.sasToken
    )

    window.location.href =
      'itms-services://?action=download-manifest&url=' + uri
  } else {
    try {
      const connectionString = () => {
        if (process.env.REACT_APP_ENV !== 'production') {
          return `${process.env.REACT_APP_CONNECTION_STRING_STG}${responseToken.data.sasToken}`
        } else {
          return `${process.env.REACT_APP_CONNECTION_STRING_PRD}${responseToken.data.sasToken}`
        }
      }

      const containerName = 'ph-mobile-apps/' + app.foldername
      const blobName =
        process.env.REACT_APP_ENV !== 'production'
          ? app.android + '_stg.apk'
          : app.android + '.apk'

      const blobServiceClient = await BlobServiceClient.fromConnectionString(
        connectionString()
      )

      const containerClient =
        blobServiceClient.getContainerClient(containerName)
      const blobClient = containerClient.getBlobClient(blobName)
      console.log('Downloading app.')
      await logEvent(analytics, `${container}-Android`, {
        platform: 'Android',
      })
      window.location.href = await (
        await blobClient.download()
      )._response.request.url
    } catch (e) {
      console.log('Fetching blob error:', e)
    }
  }
}
